const expoRouter = [
  {
    path: '/e',
    name: 'ExpoIndex',
    component: () => import('@/views/expo/index')
  },
  {
    path: '/e/:id(\\d+)',
    name: 'ExpoDetail',
    component: () => import('@/views/expo/detail')
  },
  {
    path: '/e/guest',
    name: 'ExpoGuest',
    component: () => import('@/views/expo/guest')
  },
  {
    path: '/e/join',
    name: 'ExpoJoin',
    component: () => import('@/views/expo/join')
  },
  {
    path: '/e/vote',
    name: 'ExpoVote',
    component: () => import('@/views/expo/vote')
  },
  {
    path: '/e/join/success/',
    name: 'ExpoJoinSuccess',
    component: () => import('@/views/expo/join_success')
  },
  {
    path: '/e/vote/success/',
    name: 'ExpoVoteSuccess',
    component: () => import('@/views/expo/vote_success')
  },
  {
    path: '/e/ep/create/success',
    name: 'EpCreateSuccess',
    component: () => import('@/views/expo/ep/create_success')
  },
  {
    path: '/e/ep/create',
    name: 'EpCreate',
    component: () => import('@/views/expo/ep/create')
  },
  {
    path: '/e/ep/edit/:id(\\d+)',
    name: 'EpEdit',
    component: () => import('@/views/expo/ep/edit')
  },
  {
    path: '/e/ep/edit/tag',
    name: 'EpEditTag',
    component: () => import('@/views/expo/ep/edit_tag')
  },
  {
    path: '/e/ep/:id(\\d+)',
    name: 'EpDetail',
    component: () => import('@/views/expo/ep/detail')
  },
  {
    path: '/e/ep/action/:id(\\d+)',
    name: 'EpAction',
    component: () => import('@/views/expo/ep/action')
  },
  {
    path: '/e/ep/comment/:id(\\d+)',
    name: 'EpComment',
    component: () => import('@/views/expo/ep/comment')
  }
]

export default expoRouter



// WEBPACK FOOTER //
// ./src/router/modules/expo.js